/**
 * Work Log 관련 상수 정의
 */

export type WorkLogStatus = 'IN_PROGRESS' | 'COMPLETED'
export type WorkLogCategory =
  | '장애대응'
  | '시스템점검'
  | '문의응대'
  | '신규구축'
  | 'PoC'
  | '스펙변경'
  | '오라클유지보수'
  | '지원프로세스개선'
  | '기타'

export interface WorkLog {
  id: number
  customerId: number
  customerName: string
  category: WorkLogCategory
  categoryEnglish: string
  title: string
  description: string
  status: WorkLogStatus
  expectedMinutes: number | null
  startedAt: string | number[]
  finishedAt: string | number[] | null
  durationSeconds: number | null
  createdAt: string | number[]
  updatedAt: string | number[]
}

export interface WorkLogFormData {
  customerId: number
  category: WorkLogCategory
  title: string
  description: string
  expectedMinutes: number | null
}

/**
 * 상태 관련 상수
 */
export const WORK_LOG_STATUSES: ReadonlyArray<WorkLogStatus | 'all'> = ['all', 'IN_PROGRESS', 'COMPLETED'] as const

export const STATUS_LABELS: Record<WorkLogStatus | 'all', string> = {
  all: '전체',
  IN_PROGRESS: '진행중',
  COMPLETED: '완료'
}

export const STATUS_COLORS: Record<WorkLogStatus, string> = {
  IN_PROGRESS: 'bg-yellow-100 text-yellow-800',
  COMPLETED: 'bg-green-100 text-green-800'
}

/**
 * 카테고리 관련 상수
 */
export const WORK_LOG_CATEGORIES: ReadonlyArray<WorkLogCategory | 'all'> = [
  'all',
  '장애대응',
  '시스템점검',
  '문의응대',
  '신규구축',
  'PoC',
  '스펙변경',
  '오라클유지보수',
  '지원프로세스개선',
  '기타'
] as const

export const CATEGORY_COLORS: Record<WorkLogCategory, string> = {
  장애대응: 'bg-red-100 text-red-800',
  시스템점검: 'bg-blue-100 text-blue-800',
  문의응대: 'bg-purple-100 text-purple-800',
  신규구축: 'bg-green-100 text-green-800',
  PoC: 'bg-orange-100 text-orange-800',
  스펙변경: 'bg-yellow-100 text-yellow-800',
  오라클유지보수: 'bg-indigo-100 text-indigo-800',
  지원프로세스개선: 'bg-pink-100 text-pink-800',
  기타: 'bg-gray-100 text-gray-800'
}

/**
 * 날짜/시간 관련 상수
 */
export const RECENT_DAYS_FOR_AVERAGE = 7 // 평균 계산에 사용할 최근 일수

/**
 * 배열 인덱스 상수 (Spring Boot LocalDateTime 배열)
 */
export const DATETIME_INDEX = {
  YEAR: 0,
  MONTH: 1,
  DAY: 2,
  HOUR: 3,
  MINUTE: 4,
  SECOND: 5
} as const
